import { route } from '../../../routes/web';
import { request } from '../../../functions/request';
import { openPickPoint } from './openPickPoint';
import { setShopPoint } from './setShopPoint';

export const points_request_invalid = 'points_request_invalid';
export const points_request_send = 'points_request_send';
export const points_request_valid = 'points_request_valid';

export function PointsRequestInvalid() {
    return {
        type: points_request_invalid,
    };
}

export function PointsRequestSend() {
    return {
        type: points_request_send,
    };
}

export function PointsRequestValid(data) {
    return {
        type: points_request_valid,
        data: data,
    };
}

export function fetchPoints(data) {
    return function (dispatch) {
        dispatch(PointsRequestSend());
        request(
            route.shop.points,
            data,
            (data) => {
                if (data.success && data.data_response.success) {
                    const points = data.data_response.points;
                    const savedPointId = JSON.parse(
                        localStorage.getItem('pointId')
                    );
                    const savedPoint = points.find(
                        (point) => point.id === Number(savedPointId)
                    );

                    if (points?.length === 1) {
                        dispatch(setShopPoint(points[0]));
                        dispatch(openPickPoint(false));
                    }

                    if (savedPoint) {
                        dispatch(setShopPoint(savedPoint));
                        dispatch(openPickPoint(false));
                    }

                    dispatch(PointsRequestValid(data.data_response));
                } else {
                    dispatch(PointsRequestInvalid());
                }
            },
            (error) => {
                dispatch(PointsRequestInvalid());
            }
        );
    };
}
